import doctorModule from "./module";

// Aliases for existing imports; all lifecycle actions come from the factory.
export const getDoctor = doctorModule.actions.list;
export const getDoctorDetails = doctorModule.actions.clinicDoctors;
export const addNewDoctor = doctorModule.actions.create;
export const updateDoctor = ({ id, doctor }) => doctorModule.actions.update({ id, data: doctor });
export const deleteDoctor = doctorModule.actions.delete;
export const resetDoctorState = doctorModule.actions.reset;
